

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import moment from 'moment';
import './MyBookings.css'; // You can reuse the same CSS file

const MyHotelBookings = () => {
    const { user } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        const getBookings = async () => {
            if (!user?.id) {
                setLoading(false);
                setError("User not found. Please log in again.");
                return;
            }

            try {
                // Assuming the API endpoint is correct
                const response = await apiService.post(`${config.GETUSERHOTELBOOKINGS}/${user?.id}`, { pageSize, pageNumber });
                console.log("Hotel bookings response:", response);

                // The API returns an object { data: [...] }, so we need to access the .data property
                if (response.data && Array.isArray(response.data)) {
                    setBookings(response.data);
                } else {
                    setBookings([]);
                    console.warn("API response did not contain a 'data' array.", response);
                }

            } catch (err) {
                setError("Could not fetch your hotel bookings. Please try again later.");
                console.error("Failed to fetch hotel bookings:", err);
            } finally {
                setLoading(false);
            }
        };

        getBookings();
    }, [user, pageSize, pageNumber]);

    const renderStatusBadge = (status) => {
        if (!status) return null;
        let badgeClass = 'bg-secondary';
        switch (status.toUpperCase()) {
            case 'CONFIRMED':
            case 'SUCCESS':
                badgeClass = 'bg-success';
                break;
            case 'PENDING':
            case 'HOLD':
                badgeClass = 'bg-warning text-dark';
                break;
            case 'CANCELLED':
            case 'FAILED':
                badgeClass = 'bg-danger';
                break;
            default:
                break;
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
    };

    return (
        <div className="main-content">
            <div className="bookings-card">
                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading your bookings...</p>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>S No</th>
                                    <th>Booking Info</th>
                                    <th>Location</th>
                                    <th>Stay Dates</th>
                                    <th>Guests / Rooms</th>
                                    <th>Booking Status</th>
                                    <th>Payment Status</th>
                                    <th>Total Price</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.length > 0 ? (
                                    bookings.map((booking, index) => (
                                        <tr key={booking.hotelBookingId}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <strong>{booking.bookingNo}</strong>
                                                <br />
                                                <small className="text-muted">
                                                    Booked on:{" "}
                                                    {moment(booking.bookingDate).format("DD MMM YYYY")}
                                                </small>
                                            </td>
                                            <td>
                                                <strong>{booking.city}</strong>
                                                <br />
                                                <small className="text-muted">{booking.country}</small>
                                            </td>
                                            <td>
                                                {moment(booking.checkIn).format("DD MMM YYYY")} → <br />
                                                {moment(booking.checkOut).format("DD MMM YYYY")}
                                            </td>
                                            <td>
                                                {booking.noOfGuests} Guest(s)
                                                <br />
                                                {booking.noOfRooms} Room(s)
                                            </td>
                                            <td>{renderStatusBadge(booking.bookingStatus)}</td>
                                            <td>{renderStatusBadge(booking.paymentStatus)}</td>
                                            <td>
                                                <strong>{booking.totalPrice.toFixed(2)}</strong>
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/my-hotel/booking/${booking.hotelBookingId}`}
                                                    className="btn btn-sm btn-outline-primary"
                                                >
                                                    View Details
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4">
                                            No records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
export default MyHotelBookings;